/*
 * @Author: lzy
 * @Date: 2021-05-11 15:53:07
 * @LastEditTime: 2021-05-12 11:06:13
 * @LastEditors: lzy
 * @Description: app详情页顶部操作按钮
 * @FilePath: \xjmediacloud\app\editingCenter\app\directive\previewBtns\previewBtns.js
 */

angular.module('websitePreviewModule').directive('newspaperPreviewBtns', ['$state', 'newMediaService', 'trsHttpService', 'messagePublishService', 'editNewspaperService', 'editingCenterService', 'storageListenerService', 'publicToolService', 'modalDialog',
    function($state, newMediaService, trsHttpService, messagePublishService, editNewspaperService, editingCenterService, storageListenerService, publicToolService, modalDialog) {
        return {
            scope: true,
            restrict: 'EA',
            replace: true,
            templateUrl: './editingCenter/newspaper/preview/previewBtns/previewBtns.html',
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化数据
                 *
                 * @return  {[type]}   [return description]
                 */
                function initStatus() {
                    $scope.list = $scope.item;
                }

                /**
                 * [initData description]
                 *
                 * @return  {[type]}   [return description]
                 */
                function initData() {
                    // publicToolService.getModeconfiguration('IM').then((config) => {
                    //     // 因为发送按钮不基于权限控制，只根据配置中心来决定，在这里添加可以便于修改每个编辑页面
                    //     $scope.status.canSendMessage = config && config.sendSwitch === 'on';
                    // });
                }

                /**
                 * [newsDraftShangBan description] 上版操作
                 * @return  {[type]}  [return description]
                 */
                $scope.newsDraftShangBan = function () {
                    newMediaService.shangBan($scope).then(() => {
                        messagePublishService.publish('doEditPageOperation');
                    });
                };
                
                /**
                 * [rejectionDraftofPage description] 退稿
                 *
                 * @return  {[type]}   [return description]
                 */
                $scope.rejectionDraftofPage = function() {
                    var transferDate = {
                        items: [$scope.data.item],
                        PaperDocIds: $scope.data.item.METADATAID,
                    };
                    editNewspaperService.newspaperBackManuscript(transferDate, function(result) {
                        afterOper();
                    });
                };

                /**
                 * [newsDraftDaiYong description] 待用操作
                 * @return  {[type]}  [return description]
                 */
                $scope.newsDraftDaiYong = function () {
                    newMediaService.daiYong($scope).then(() => {
                        messagePublishService.publish('doEditPageOperation');
                    });
                };

                /**
                 * [newsDraftZhuanBan description] 转版操作
                 * @return  {[type]}  [return description]
                 */
                $scope.newsDraftZhuanBan = function () {
                    newMediaService.zhuanBan($scope).then(() => {
                        messagePublishService.publish('doEditPageOperation');
                    });
                };

                /**
                 * [newsDraftZhaoPai description] 签发照排
                 * @return  {[type]}  [return description]
                 */
                $scope.newsDraftZhaoPai = function () {
                    $scope.status.newInformation = $scope.data.paperMsg;
                    newMediaService.newsSign($scope);
                };

                /**
                 * [newsDraftCheGao description] 撤稿操作
                 * @return  {[type]}  [return description]
                 */
                $scope.newsDraftCheGao = function () {
                    newMediaService.newsPaperChegao($scope).then(() => {
                        messagePublishService.publish('doEditPageOperation');
                    });
                };

                /**
                 * [sendNews description] 传稿
                 * @return  {[type]}  [return description]
                 */
                $scope.sendNews = function () {
                    newMediaService.newsChuanGao($scope).then(() => {
                        messagePublishService.publish('doEditPageOperation');
                    });
                };

                /**
                 * [revise description]修订
                 * @return {[type]} [description]
                 */
                $scope.revise = function () {
                    var methodname = ['appointDocToUserOfDyg', 'appointDocToUserOfJrg', 'appointDocToUserOfSbg'];
                    var transferData = {
                        serviceid: 'mlf_papermodify',
                        methodname: methodname[$state.params.newspapertype],
                        PaperId: $scope.data.item.SITEID,
                        PaperDocIds: $scope.data.item.METADATAID,
                    };
                    newMediaService.revise($scope, transferData).then(function() {
                        afterOper();
                    });
                };

                // 取消签发
                $scope.retraction = function() {
                    newMediaService.paperCancelSignedDraft($scope);
                };

                $scope.distribution = function() {
                    if ($scope.data.item.DOCTYPEID === '1') {
                        editingCenterService.distribution([$scope.data.item], '3', $scope.data.item.DOCTYPEID, 'paperYiQianFaDistribute');
                    } else {
                        modalDialog.alertType('', '多元分发仅支持的稿件类型为新闻', 'warning', 'confirm');
                    }
                };

                /**
                 * [tenantManuShare 租户间共享]
                 * @return {[type]} [description]
                 */
                $scope.tenantManuShare = function () {
                    editingCenterService.isListDocCanOper($scope.data.item.CHNLDOCID).then(function (data) {
                        var params = {
                            serviceid: 'mlf_paper',
                            methodname: 'pluralisticShare',
                            dataIds: $scope.data.item.METADATAID,
                            PaperId: $scope.data.item.SITEID,
                        };
                        $scope.loadingPromise = editingCenterService.tenantShareManu(params);
                    });
                };

                /**
                 * [tenantManuShare 共享到已定稿库]
                 * @return {[type]} [description]
                 */
                $scope.shareToYd = function () {
                    editingCenterService.isListDocCanOper($scope.data.item.CHNLDOCID).then(function (data) {
                        if ($scope.data.item.ISSHARE === '1') {
                            modalDialog.alertType('所选稿件中含有共享过的稿件，不能再次共享', '', 'warning', 'cancel');
                            return;
                        }
                        var params = {
                            serviceid: 'mlf_paper',
                            methodname: 'ydShare',
                            DocIds: $scope.data.item.METADATAID,
                        };
                        editingCenterService.shareToYd(params).then(function (data) {
                            if (data === 'success') {
                                afterOper();
                            }
                        });
                    });
                };

                /**
                 * [archive description]归档操作
                 * @return {[type]} [description]
                 */
                $scope.archive = function() {
                    editNewspaperService.archive([$scope.data.item], function(data) {
                        afterOper();
                    });
                };
        
                /**
                 * [reduction description]还原操作
                 * @return {[type]} [description]
                 */
                $scope.reduction = function() {
                    editingCenterService.isListDocCanOper($scope.data.item.CHNLDOCID).then(function(data){
                        modalDialog.inputModel('还原', '还原意见（可选）', function(content) {
                            var params = {
                                serviceid: 'mlf_paper',
                                methodname: 'doRestore',
                                SrcDocIds: $scope.data.item.METADATAID,
                                Option: content
                            };
                            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                                modalDialog.alertType('', '还原成功', 'success', false, function() {
                                    afterOper();
                                });
                            });
                        });
                    });
                };

                /**
                 * [deleteNews description]
                 *
                 * @return  {[type]}  [return description]删除稿件
                 */
                $scope.deleteNews = function() {
                    editingCenterService.isListDocCanOper($scope.data.item.CHNLDOCID).then(function(data){
                        modalDialog.confirmModal('删除', '确定删除所选稿件吗', function() {
                            var params = {
                                serviceId: 'mlf_paper',
                                methodName: 'trashMetaDatas',
                                DocIds: $scope.data.item.METADATAID,
                            };
                            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                                modalDialog.multiReportsAlert(data, function() {
                                    afterOper();
                                });
                            });
                        });
                    });
                };

                /**
                 * [afterOper description] 操作完成后执行，用于刷新列表页面和关闭页面
                 *
                 * @return  {[type]}   [return description]
                 */
                function afterOper() {
                    storageListenerService.addListenerToNewspaper();
                    window.close();
                }
            }
        };
    }
]);
